//Part 1: TODO import data from data/0723.json

//Part 2: Format Data for chartJS
const station1 = 'Station A';
const date1 = '7-23-2019';
const time1 = ['17:10', '17:11', '18:45', '20:54', '21:49', '21:50', '22:02', '22:03'];
const energy1 = [0, 15.14, 5.18, 13.48, 0, 8.26, 20, 14.43];
const co21= [0, 28.63, 22.95, 27.68, 0, 24.71, 0, 27.79];
const cost1 = [0, 8.63, 2.95, 7.68, 0, 4.71, 0, 7.79];
const mark1 = '15:49:41';

//Part 3 Export Data for ChartJs
export const stationName = station1;

export const sessionDate = date1;

export const dataLabelTime = time1;

export const dataLineEnergy = 
{
  data: energy1, 
  label: 'Energy kHz Used '
}

export const dataLineCost = 
{
  data: cost1, 
  label: 'Amount Charged'
}




